import React from 'react';
import { Typography, Tooltip, Flex, Progress, Button } from 'antd';
import { useNavigate, useSelector } from '@umijs/max';
import BoltIcon from '../Icons/bolt';
import { useMediaQuery } from 'react-responsive';

const { Text } = Typography;

const HeaderCreditsMeter = () => {
    const { subscription, people_credits_remaining } = useSelector((state: any) => state.subscription)

    const navigate = useNavigate();
    const isFreeUser = subscription?.name === 'Free';

    // Responsive breakpoint for tablet mode
    const isTabletOrMobile = useMediaQuery({ maxWidth: 968 });

    if (!subscription) return null;

    const rawPeopleCreditsMax = subscription?.subscriptionFeatures?.find(
        (feature: any) => feature.feature?.key === 'people_credits',
    )?.value;
    const parsedPeopleCreditsMax = Number(rawPeopleCreditsMax);
    const peopleCreditsMax =
        Number.isFinite(parsedPeopleCreditsMax) && parsedPeopleCreditsMax > 0
            ? parsedPeopleCreditsMax
            : 0;
    const hasFinitePeopleMax = peopleCreditsMax > 0;

    const peopleCreditsPercentage = hasFinitePeopleMax
        ? Math.min(100, (people_credits_remaining / peopleCreditsMax) * 100)
        : 100;
    const peopleCreditsLabel = hasFinitePeopleMax
        ? `${people_credits_remaining}/${peopleCreditsMax}`
        : `${people_credits_remaining} left`;

    return (
        <Flex align="center" gap={12} onClick={() => navigate('/pricing')} style={{ cursor: 'pointer' }}>
            <Flex vertical gap={0}>
                <Flex align="center" justify="space-between" style={{ marginBottom: 1 }}>
                    <Text strong style={{ fontSize: '10px', lineHeight: '12px', margin: 0, paddingRight: '10px' }}>People Credits</Text>
                    <Text style={{ fontSize: '10px', lineHeight: '12px', margin: 0 }}>{peopleCreditsLabel}</Text>
                </Flex>
                <Progress
                    percent={peopleCreditsPercentage}
                    showInfo={false}
                    size="small"
                    strokeColor="#1890ff"
                    trailColor="#f0f0f0"
                    strokeWidth={4}
                    style={{ margin: 0 }}
                />
            </Flex>

            {isFreeUser && (
                <Button
                    size={"small"}
                    style={{ backgroundColor: '#FFCD00', color: '#000', borderColor: '#FFCD00', fontSize: '10px' }}
                    onClick={() => navigate('/pricing')}
                >
                    {isTabletOrMobile ? 'Upgrade' : 'Upgrade Plan'}
                    <BoltIcon color="#000" />
                </Button>
            )}
        </Flex>
    );
};

export default HeaderCreditsMeter; 
